import urls from '@/navigation/urls'

const unsavedRoutes = [urls.auth, urls.home, urls.main]

const syncHistoryСonstants = { unsavedRoutes }

export default syncHistoryСonstants
